import { DeliveryOptions } from '../delivery-options';
import { DeliveryOptionsDto } from '../dto/delivery-options-dto';
import { mapAddress } from './address-mapper';

export const mapDeliveryOptions = (deliveryOptions: DeliveryOptionsDto): DeliveryOptions => ({
    avisoContacts: deliveryOptions.avisoContacts,
    desiredDeliveryDate: deliveryOptions.desiredDeliveryDate,
    deliveryAddresses: deliveryOptions.deliveryAddresses?.map(mapAddress) ?? [],
    invoiceAddresses: deliveryOptions.invoiceAddresses?.map(mapAddress) ?? [],
    defaults: {
        deliveryAddressId: deliveryOptions.defaults?.deliveryAddressId ?? null,
        invoiceAddressId: deliveryOptions.defaults?.invoiceAddressId ?? null,
        costCentre: deliveryOptions.defaults?.costCentre ?? '',
        avisoContactId: deliveryOptions.defaults?.avisoContactId ? deliveryOptions.defaults.avisoContactId : null,
    },
});
